import PropTypes from 'prop-types';
import { CurrencyInput } from '@figure/frontlib-gui';

const IncomeSectionForm = ({
  fieldName,
  label,
  values,
  errors,
  touched,
  setFieldValue,
  warning,
  onBlur,
  asterisks,
  descriptiveTextId,
  isRequiredField,
}) => (
  <>
    <CurrencyInput
      id={`${fieldName}-amount`}
      label={label}
      name={`${fieldName}-amount`}
      data-test-id={`${fieldName}-amount`}
      value={values[fieldName].amount}
      placeholder="$"
      maxLength="10"
      errorText={touched[fieldName] && touched[fieldName].amount && errors[fieldName] && errors[fieldName].amount}
      onChange={(value) => {
        // TODO: determine why types of onChange values differ
        let parsedValue = value;
        if (typeof value === 'string') parsedValue = value.length > 0 ? Number.parseInt(value, 10) : undefined;

        setFieldValue(`${fieldName}.amount`, parsedValue);
      }}
      onBlur={onBlur}
      warning={warning}
      asterisks={asterisks}
      descriptiveTextId={descriptiveTextId}
      required={isRequiredField}
    />
  </>
);

IncomeSectionForm.propTypes = {
  fieldName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  errors: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  touched: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  setFieldValue: PropTypes.func.isRequired,
  warning: PropTypes.bool,
  onBlur: PropTypes.func,
  asterisks: PropTypes.number,
  descriptiveTextId: PropTypes.string,
  /** boolean used to set whether or not the field is required */
  isRequiredField: PropTypes.bool,
};

IncomeSectionForm.defaultProps = {
  warning: false,
  onBlur: () => {},
  asterisks: null,
  descriptiveTextId: null,
  isRequiredField: false,
};

export default IncomeSectionForm;
